// ignore-string-externalization
import { createLoader } from '@spotify-internal/creator-data-loading';
import { fetchEntry, fetchEntryList } from '../Contentful';
import logger from '@spotify-internal/isomorphic-logger';
import { getHelpHomePage } from './graphql/getHelpHomePage';

var helpLoader = function helpLoader(query) {
  var loader = createLoader(function (params) {
    return query(params).then(function (result) {
      return result || undefined;
    }).catch(function (e) {
      logger.error(e);
      return undefined;
    });
  }, {
    cacheKeyFn: JSON.stringify
  });
  return function (params) {
    return loader.load(params);
  };
};

export var loadHome = helpLoader(function (_ref) {
  var preview = _ref.preview,
      smartlingLanguage = _ref.smartlingLanguage;
  return getHelpHomePage(preview, smartlingLanguage);
});
export var loadCategory = helpLoader(function (_ref2) {
  var key = _ref2.key,
      preview = _ref2.preview,
      smartlingLanguage = _ref2.smartlingLanguage;
  return key ? fetchEntry({
    contentType: 'faqCategory',
    filters: {
      urlSlug: key
    },
    locale: smartlingLanguage,
    preview: preview
  }) : Promise.reject('category urlSlug not provided');
});
export var loadRelatedCategory = helpLoader(function (_ref3) {
  var key = _ref3.key,
      preview = _ref3.preview,
      smartlingLanguage = _ref3.smartlingLanguage;
  return fetchEntryList({
    contentType: 'faqCategory',
    linksToEntry: key,
    locale: smartlingLanguage,
    preview: preview
  }).then(function (result) {
    var _result$entries;

    return result === null || result === void 0 ? void 0 : (_result$entries = result.entries) === null || _result$entries === void 0 ? void 0 : _result$entries[0];
  });
});
export var loadFaq = helpLoader(function (_ref4) {
  var key = _ref4.key,
      preview = _ref4.preview,
      smartlingLanguage = _ref4.smartlingLanguage;
  return key ? fetchEntry({
    contentType: 'faq',
    filters: {
      urlSlug: key
    },
    locale: smartlingLanguage,
    preview: preview
  }) : Promise.reject('faq urlSlug not provided');
});